@use 'colors';
@use 'common';
@use 'ant-override';
@use 'breakpoints';

html {
  // Z-indices;
  --z-index-light: 100;
  --z-index-medium: 200;
  --z-index-important: 999;
  --z-index-top: 9999;

  // Size variables;
  --max-screen-width: 1920px;
  --header-height: 64px;
  --pagination-height: 40px;
  --min-content-height: calc(100vh - var(--header-height));
  --default-border-radius: 8px;
  --dimension-by-size-small-width: 36px;
  --dimension-by-size-small-height: 48px;
  --dimension-by-size-medium-width: 48px;
  --dimension-by-size-medium-height: 64px;

  // Typography;
  --typography-size12: 0.75rem;
  --typography-size14: 0.875rem;
  --typography-size16: 1rem;
  --typography-size18: 1.125rem;
  --typography-size20: 1.25rem;
  --typography-size22: 1.375rem;
  --typography-size24: 1.5rem;
  --typography-size26: 1.625rem;
  --typography-size28: 1.75rem;
  --typography-size30: 1.875rem;
  --typography-size32: 2rem;
  --typography-size34: 2.125rem;
  --typography-size36: 2.25rem;
  --typography-size38: 2.375rem;
  --typography-size40: 2.5rem;

  // Color variables;
  --color-default: rgb(0, 0, 0, 0.85);
  --color-secondary: rgb(0, 0, 0, 0.45);
  --color-background-disabled: rgb(0, 0, 0, 0.04);
  --color-background-light: rgb(0, 0, 0, 0.02);
  --color-border-info-table: rgb(0, 0, 0, 0.06);
  --color-border: rgb(0, 0, 0, 0.15);
  --color-main-1: #22BDFF; //  var(--color-ibm-carbon-blue-6);
  --color-selected-table-row: var(--color-ibm-carbon-blue-1);
  --color-warning: var(--color-gold-6);
  --color-success: var(--color-green-6);
  --color-error-light: var(--color-red-1);
  --color-warning-alt: var(--color-purple-2);
  --color-warning-heavy: var(--color-orange-4);
  --color-icon-default: #979797;
  --color-icon-hover: #161616;
  --color-header: #001529;
  --color-shadow: rgb(0, 0, 0, 0.03);
  --color-link: var(--color-ibm-carbon-blue-6);
  --color-link-hover: var(--color-ibm-carbon-blue-5);
  --color-scroll-bar: rgb(0, 0, 0, 0.1);
  --color-scroll-bar-hover: rgb(0, 0, 0, 0.2);

  // Danger colors;
  --color-danger-medium: var(--color-red-5);
  --color-danger-light: var(--color-red-4);
  --color-danger-heavy: var(--color-red-6);

  /* Presale colors */
  --color-warning-presale: var(--color-orange-2);
  --color-presale-dead-deal: var(--color-purple-3);
  --color-presale-form-delimiter: var(--color-orange-7);
  --color-presale-background-critical: var(--color-red-3);
  --color-presale-background-unusual: var(--color-purple-1);
  --color-presale-border-critical: var(--color-red-3);
  --color-presale-border-unusual: var(--color-purple-5);
  --color-presale-text-critical: var(--color-red-6);
  --color-presale-text-unusual: var(--color-purple-6);
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  scrollbar-color: var(--color-scroll-bar) transparent;
  scrollbar-width: thin;
}

body {
  height: 100vh;
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: var(--color-default);

  overflow-y: scroll !important;
}

#root {
  height: 100%;
}

::-webkit-scrollbar {
  width: 20px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: var(--color-scroll-bar);
  border-radius: 20px;
  border: 6px solid transparent;
  background-clip: content-box;
}

::-webkit-scrollbar-thumb:hover {
  background-color: var(--color-scroll-bar-hover);
}

*:hover {
  scrollbar-color: var(--color-scroll-bar-hover) transparent;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  appearance: none;
  margin: 0;
}

input[type='number'] {
  appearance: textfield;
}